import styled, { css } from 'styled-components';
import { Button, ButtonColors } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/stats_premium_bg.jpg';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	grid-template-rows: 194px;
	gap: 20px;
	padding: 0 40px 40px;
	margin: 0 auto;
`;

const StyledCard = styled.div<{ $disabled?: boolean; $span?: number }>`
	position: relative;
	display: ${(props) => (props.$disabled ? 'none' : 'flex')};
	flex-direction: column;
	grid-column: ${(props) => (props.$span ? `span ${props.$span}` : 'auto')};
	justify-content: space-between;
	height: 194px;
	padding: 37px 40px 34px;
	border-radius: 5px;
	border: 1px solid rgba(255, 255, 255, 0.05);
	background-color: rgba(255, 255, 255, 0.02);

	.title {
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		opacity: 0.5;
	}

	& > ${Text} {
		color: #ffffff;
	}
`;

const StyledPremiumCard = styled(StyledCard)<{ $active?: boolean }>`
	${(props) =>
		props.$active &&
		css`
			background-image: url(${bg});
			border: 1px solid transparent;

			.title {
				font-size: 16px;
				line-height: 18px;
				color: #000000;
				opacity: 0.5;
			}

			& > ${Text} {
				color: #000000;

				span {
					color: #794916;
				}
			}
		`}
`;

const StyledCardBottom = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	& > ${Text} {
		color: #ffffff;
	}
`;

const StyledDateContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	${Text} {
		color: #ffffff;
		font-size: 26px;
	}

	img {
		width: 20px;
		height: 20px;
		opacity: 0.5;
		margin-top: -2px;
	}
`;

const StyledTime = styled(Text)`
	color: #ffffff;

	span {
		font-size: 20px;
		opacity: 0.5;
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	align-items: center;
	gap: 10px;
	grid-template-columns: 50px 60px 60px 100px;
`;

const StyledButton = styled(Button)<{ $active?: boolean }>`
	${Text} {
		white-space: nowrap;
	}

	${(props) =>
		props.$active &&
		css`
			background-color: ${ButtonColors.Select};
		`}
`;

const StyledMoneyContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		color: #ffffff;
		font-size: 26px;
	}

	img {
		margin-top: -1px;
	}
`;

export {
	StyledButton,
	StyledButtonsContainer,
	StyledCard,
	StyledCardBottom,
	StyledContainer,
	StyledDateContainer,
	StyledMoneyContainer,
	StyledPremiumCard,
	StyledTime,
};
